<template>
  <v-container id="regular-forms" fluid tag="section">
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="primary"
          icon="mdi-account"
          :title="
            $route.params.id ? $t('Edit Numberrange') : $t('New Numberrange')
          "
          class="px-5 py-3"
        >
          <v-progress-linear
            indeterminate
            rounded
            height="6"
            v-if="loading"
          ></v-progress-linear>
          <v-form
            v-else
            ref="form"
            autocomplete="new-password"
            lazy-validation
            @submit.prevent="saveItem"
          >
            <v-text-field
              v-model="formValues.name"
              label="Name"
              v-validate="'required'"
              required
              class="mt-5"
              outlined
              data-vv-name="name"
              :error-messages="errors.collect('name')"
            ></v-text-field>
            <v-text-field
              v-model="formValues.schema"
              label="Schema"
              v-validate="'required'"
              required
              outlined
              data-vv-name="schema"
              :error-messages="errors.collect('schema')"
            ></v-text-field>

            <v-select
              v-model="formValues.certificate_type"
              :items="certificate_types"
              :label="$t('certificate_type')"
              item-text="name"
              item-value="id"
              outlined
              :placeholder="$t('certificate_type')"
              v-validate="'required'"
              data-vv-name="certificate_type"
              :error-messages="errors.collect('certificate_type')"
            ></v-select>

            <v-card color="#eeeeee" dark>
              <v-card-title>
                Schema Konfiguration
              </v-card-title>
              <v-card-text>
                <p>
                  <small
                    >%Y -> Jahr 4 Stellen<br />
                    %y -> Jahr 2 Stellen<br />
                    %M -> Monat<br />
                    %D -> Tag<br />
                    %W -> Kalenderwoche<br />
                    %N5 -> Fortlaufende Nummer, wobei die Zahl die Anzahl der
                    Ziffern angibt</small
                  >
                </p>
              </v-card-text>
            </v-card>

            <v-select
              v-model="formValues.country_id"
              :items="countries"
              :label="$t('country')"
              item-text="name"
              item-value="id"
              clearable="true"
              outlined
              :placeholder="$t('generic_country')"
              persistent-hint="true"
              v-validate=""
              data-vv-name="country_id"
              :error-messages="errors.collect('country_id')"
            ></v-select>
            <v-checkbox
              v-model="formValues.number_per_company"
              :label="$t('number_per_company')"
              data-vv-name="number_per_company"
              :error-messages="errors.collect('number_per_company')"
            ></v-checkbox>
            <v-checkbox
              v-model="formValues.generic"
              :label="$t('generic')"
              data-vv-name="generic"
              :error-messages="errors.collect('generic')"
            ></v-checkbox>
            <v-select
              :disabled="formValues.generic || formValues.number_per_company"
              v-model="formValues.label_type_id"
              :items="labeltypes"
              :label="$t('label_type')"
              item-text="name"
              item-value="id"
              required
              outlined
              v-validate="'required'"
              data-vv-name="label_type_id"
              :error-messages="errors.collect('label_type_id')"
            ></v-select>
            <v-text-field
              v-model="formValues.last_no"
              :label="$t('last_no')"
              data-vv-name="last_no"
              outlined
              :error-messages="errors.collect('last_no')"
            ></v-text-field>

            <v-card-actions class="pl-0">
              <v-btn
                color="primary"
                class="mr-4"
                @click="$router.push({ name: 'numberRange.index' })"
              >
                {{ $t("back") }}
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" class="mr-4" @click="saveItem">
                {{ $t("save") }}
              </v-btn>
            </v-card-actions>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  saveItem,
  fetchItem,
  fetchCountries,
  fetchLabeltypes
} from "../shared/services";

export default {
  name: "app-numberRange-item",
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      formValues: {},
      door_types: [],
      countries: [],
      labeltypes: [],
      loading: true
    };
  },
  mounted() {
    fetchCountries().then(res => {
      this.countries = res.data;
    });
    fetchLabeltypes().then(res => {
      this.labeltypes = res.data;
    });
    if (this.$route.params.id) {
      this.loading = true;
      fetchItem(this.$route.params.id).then(res => {
        this.formValues = res.data;
        this.loading = false;
      });
    } else {
      this.loading = false;
    }
  },
  computed: {
    computedFormValues() {
      return {
        ...this.formValues
      };
    },
    certificate_types() {
      return [
        { name: "Standard", id: "standard" },
        { name: "Moralt", id: "moralt" }
      ];
    }
  },
  methods: {
    async saveItem() {
      this.$validator.reset();
      this.$validator.validateAll();
      let resp = await saveItem(
        this.$route.params.id,
        this.computedFormValues,
        this.$validator
      );
      if (resp.success) {
        this.$root.$notification(resp.message, { type: "success" });
        this.$router.push({ name: "numberRange.index" });
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
